import styled from 'styled-components'

const HeaderTitle = styled.div`
  display: inline-block;
  flex: 0 1 75%;
  font-size: 1.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default HeaderTitle;
